import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "@/data/content";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-white">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="mb-14">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e02329] mb-3">FAQ</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1c4f9c]">
            Answers to common questions
          </h2>
        </div>

        <div className="divide-y divide-slate-200 border-y border-slate-200">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 py-6 text-left group"
                >
                  <span className="text-lg font-bold text-[#1c4f9c] group-hover:text-[#e02329] transition-colors duration-200">{f.q}</span>
                  <span className="w-8 h-8 shrink-0 flex items-center justify-center bg-[#1c4f9c]/10 text-[#1c4f9c] rounded-sm">
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-60 pb-6" : "max-h-0"}`}>
                  <p className="text-base text-slate-600 leading-relaxed pr-12">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
